import React from 'react';
import RecordsProgressive from './records-progressive';

const RechargeRecords = () => {
  return <RecordsProgressive type="recharge" />;
};

export default RechargeRecords;
